import { AssigneeOption } from '@user/store/salesTeam/typings'
import { ServiceConfig } from '@user/store/services/config'
import { post } from '@user/store/services/crud'

const baseUrl = `${ServiceConfig.baseAPIUrl}/salesTeam/GetSalesTeamsUsersByTeam`

export const getUserListForSalesTeamsByTeam = async (
  ids: number[],
): Promise<AssigneeOption[] | undefined> => {
  if (ids && !!ids.length) {
    try {
      const response = await post(`${baseUrl}`, ids)

      if (response.ok) {
        const userList: AssigneeOption[] = await response.json()

        return userList.map((x) => ({
          id: x.userId,
          userId: x.userId,
          name: x.name,
          isActive: x.isActive,
          isAdmin: x.isAdmin,
          salesTeamId: x.salesTeamId,
        }))
      } else {
        return []
      }
    } catch {
      return undefined
    }
  } else {
    return []
  }
}
